var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fy_header'),_vm._v(" "),_c('fy_banner'),_vm._v(" "),_c('fy_tabbar',{attrs:{"title":_vm.title,"product-list":_vm.productList,"extend":[],"is-service":true},on:{"clickTab":_vm.clickTab}}),_vm._v(" "),_c('fy_footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ea8dec2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/service.vue
// module id = null
// module chunks = 